import { render, staticRenderFns } from "./RecipientBubble.vue?vue&type=template&id=1ea8c730&scoped=true"
import script from "./RecipientBubble.vue?vue&type=script&lang=js"
export * from "./RecipientBubble.vue?vue&type=script&lang=js"
import style0 from "./RecipientBubble.vue?vue&type=style&index=0&id=1ea8c730&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ea8c730",
  null
  
)

export default component.exports